import config from "../../../config/config.json";
import { headers } from "../../../APIHelpers/Headers";
import {
  handleResponse,
  headersWithAuth,
  headersWithAuthWithoutBody,
} from "../../../APIHelpers/Responses";

export const eiwrsUnblindingEmergencyRequestServices = {
  //Emergency Unblinding
  addNewEIWRSUnblindingEmergencyRequest,
  updateStatusEIWRSUnblindingEmergencyRequestData,
  getEIWRSUnblindingEmergencyRequestData,
  getEIWRSUnblindingEmergencyRequestStats
};

// Add New Emergency Unblinding
async function addNewEIWRSUnblindingEmergencyRequest(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}addNewEIWRSUnblindingEmergencyRequest`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data;
}

// Update Emergency Unblinding
async function updateStatusEIWRSUnblindingEmergencyRequestData(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}updateStatusEIWRSUnblindingEmergencyRequestData`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data
}

// Get Emergency Unblinding
async function getEIWRSUnblindingEmergencyRequestData(status, studyId, searchData, page, length) {
  let response
  if (page && length) {
    response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getEIWRSUnblindingEmergencyRequestData/${status}/${studyId}?search=${searchData || ""}&page=${page}&length=${length}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  } else {
    response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getEIWRSUnblindingEmergencyRequestData/${status}/${studyId}?search=${searchData || ""}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  }
  const data = await response.json();
  return data;
}

// Get Emergency Unblinding Request Stats
async function getEIWRSUnblindingEmergencyRequestStats(studyId, mode) {
  let response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getEIWRSUnblindingEmergencyRequestStats/${studyId}/${mode}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  const data = await response.json();
  return data;
}